import { taskStatusMap } from "../components/Widgets/SingleCounter/useCount/fetchTaskCount";
import { fetchMailMergedContent } from "../network/service";
import { getUserDetails } from "./authUtils";
import { CONSTANTS, tabTypes, timezones, widgetTypes } from "./constants";

const leadWidgetTileStyles = [
  { key: "Icon", value: "Icon" },
  { key: "Image", value: "Image" },
];
const object360WidgetTypes = {
  SINGLE_COUNTER: "singlecounter",
  BANNER: "banner",
  WEB_VIEW: "webview",
  TILE: "tile",
};

const getWidgetType = (widgetConfig) => {
  const { tileStyle, showCount, widgetStyle, widgetType } = widgetConfig;
  if (widgetStyle === "Detailed" && widgetType === "customwidget")
    return object360WidgetTypes.WEB_VIEW;
  if (tileStyle === leadWidgetTileStyles[1].value)
    return object360WidgetTypes.BANNER;
  if (tileStyle === leadWidgetTileStyles[0].value)
    return showCount
      ? object360WidgetTypes.SINGLE_COUNTER
      : object360WidgetTypes.TILE;

  return null;
};
const getCache = () => {
  return JSON.parse(localStorage.getItem(CONSTANTS.lead360CacheName) || "{}");
};

const setCache = (cache) => {
  localStorage.setItem(CONSTANTS.lead360CacheName, JSON.stringify(cache));
};

const fetchLeadIdFromURL = () => {
  const url = window.location.href;
  const params = new URL(url).searchParams;
  return params.get("LeadID");
};

export const getUserStandardTimeZone = () => {
  const userDetails = getUserDetails();
  const userTimezone = timezones.find(
    (timezone) => timezone.value.split("$")[1] === userDetails?.TimeZone
  );
  return userTimezone?.value?.split("$")[0] ?? "";
};
const getTaskFilter = (config) => {
  return {
    status: taskStatusMap[config?.taskStatus] ?? -1,
  };
};
const getOpportunityFilter = (config) => {
  return {
    code: config?.opportunityTypes?.[0]?.code,
  };
};
const getActivityFilter = (config) => {
  return {
    activityTypes: config?.activityTypes || [],
    dateFilter: {
      type: config?.dateFilters?.id,
    },
  };
};
const openTab = (type, filters) => {
  window?.lead360HelperUtils?.openTab(type, filters);
};

const openWidgetTab = (config) => {
  const widgetType = config?.widgetType;
  switch (widgetType) {
    case widgetTypes.ABOUT:
      openTab(tabTypes[widgetType]);
      break;
    case widgetTypes.NOTES:
      openTab(tabTypes[widgetType]);
      break;
    case widgetTypes.DOCUMENTS:
      openTab(tabTypes[widgetType]);
      break;
    case widgetTypes.TASKS:
      openTab(tabTypes[widgetType], getTaskFilter(config));
      break;
    case widgetTypes.OPPORTUNITIES:
      openTab(tabTypes[widgetType], getOpportunityFilter(config));
      break;
    case widgetTypes.ACTIVITES:
      openTab(tabTypes[widgetType], getActivityFilter(config));
  }
};

export const openExternalUrl = async (url) => {
  if (!hasMailMerge(url)) {
    window.open(url, "_blank");
    return;
  }
  const body = {
    data: url,
    leadId: fetchLeadIdFromURL(),
  };
  const response = await fetchMailMergedContent(body);
  window.open(response.data, "_blank");
};

export const onWidgetClick = (config) => {
  const widgetType = config?.widgetType;
  if (widgetType === widgetTypes.CUSTOM_WIDGET) {
    openExternalUrl(config?.url);
    return;
  }
  if (typeof window?.lead360HelperUtils?.openTab !== "function") return;
  openWidgetTab(config);
};

const isMiP = () => {
  return !!document?.getElementById("mip_pre_reqdata");
};


const mailMergePattern = /@\{([\w-]+):([\w\s[\]-]+),\s?\}/;

const hasMailMerge = (url) => {
  return mailMergePattern.test(url);
};

export {
  getWidgetType,
  getCache,
  setCache,
  fetchLeadIdFromURL,
  isMiP,
  hasMailMerge,
};
